// In pixels. The width the user drags to is remembered, within these bounds.
export const NAVIGATION_DRAWER_WIDTH = {
  default: 220,
  min: 180,
  max: 350,
  collapsed: 48,
  mobile: 280,
};
